import React from 'react';
import { Button, Dropdown } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import Loading from '../../loadings';
import $ from "jquery";
import Server from '../../../functions/server';
import { withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Divider from '@material-ui/core/Divider';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import Slide from '@material-ui/core/Slide';


const styles = { appBar: { position: 'relative', }, flex: { flex: 1, }, };


class AssignBranch extends React.Component {

  state = {
    maxWidth: 'lg', branchOption: []
  }


  getBranch() {
    if (!this.props.menuPermission.edit) {
      alert('You Are Not Allow To Edit This Function!!!');
      return;
    }
    let context = this;
    context.setState({ load: true, message: 'Getting Branchs' });
    $.ajax({
      type: 'POST',
      url: Server() + 'branchdetails/getallbranchs.php',
      success: function(data) {
        try {
          data = JSON.parse(data);
          context.setState({ load: false, branchOption: data, openAssginBranchDialog: true, selectedBrach: context.props.branch });
        } catch (e) {
          context.setState({ load: false });
        }
      },
      error: function(e) {
        alert('Try again!!')
        context.setState({ load: false });
      }
    });
  }

  submit() {
      let context = this;
      $.ajax({
        type: 'POST', data: {'id': context.props.id, 'branch': context.state.selectedBrach },
        url: Server()+'/quotation/assignquotationtoanotherbranch.php',
        success: function(data) {
            console.log(data);
          if (data == 1) {
            context.setState({ openAssginBranchDialog: false, load: false })
            context.props.getQuotation();
          }
          else {
            context.setState({ load: false, })
          }
        },
        error: function(e) {
          context.setState({ load: false, })
        }
      });
  }

  selectBranch = (f, { value }) => {
      this.setState({ selectedBrach: value })
  }

  render() {
    let branchOption = this.state.branchOption;
    let branch = [];
    branchOption.map((c) => {
        branch.push({ key: c.name, text: c.name, value: c.id })
    })
    return (
      <div>
        <b style={{color: 'blue'}} onClick={this.getBranch.bind(this)}>Assign</b>
        <Loading load={this.state.load} message={this.state.message} />
        <Dialog fullWidth={this.state.fullWidth} maxWidth={this.state.maxWidth}
          open={this.state.openAssginBranchDialog} aria-labelledby="max-width-dialog-title">
          <DialogTitle id="max-width-dialog-title" style={{width: '600px'}}>Quotation Assign To Another Branch</DialogTitle>
          <DialogContent style={{height: '200px'}}>
          <Dropdown fluid onChange={this.selectBranch}
            search selection options={branch}
            value={this.state.selectedBrach} fluid style={{ borderColor: '#5A9CBB' }} />
          </DialogContent>
          <DialogActions>
            <Button onClick={ () => { this.setState({ openAssginBranchDialog: false }) }}>Cancel</Button>
            <Button onClick={this.submit.bind(this)}>Submit</Button>
          </DialogActions>
        </Dialog>
          
      </div>
    );
  }
}

AssignBranch.propTypes = { classes: PropTypes.object.isRequired, };

export default withStyles(styles)(AssignBranch);
